import RestService from '../services/rest';

async function getAllTypeSolution(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/TypeSolution/all?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getTypeSolutionOptions(search) {
  return RestService.getAuthenticated(
    `panel/TypeSolution/options?search=${search}`,
  );
}

async function createTypeSolution(newTypeSolution) {
  return RestService.postAuthenticated(
    'panel/TypeSolution/create', newTypeSolution,
  );
}

async function updateTypeSolution(updTypeSolution) {
  return RestService.putAuthenticated(
    'panel/TypeSolution/update', updTypeSolution,
  );
}

export default {
  getAllTypeSolution,
  getTypeSolutionOptions,
  createTypeSolution,
  updateTypeSolution,
};
